import React, { useRef, useMemo, useEffect } from 'react';
import { Grid } from 'react-virtualized';
import 'react-virtualized/styles.css';
import FeaturesRow from "./FeaturesRow";
import { connect } from "react-redux";
import { getGridColumnDimensions, useGridDimensions } from "./gridDimensions";
import {setActiveFeatureItem} from "../../../../../../../actions/sqftFeaturesGridFunctions";

const FeaturesGrid = ({
                        lookViewType,
                        navItems,
                        featureGroup,
                        isMobile,
                        windowHeight,
                        itemClickCallback,
                        defaultActiveFeatureIndex = -1,
                        shouldShowFullHeight = false,
                        partId,
                        activeFeatureItems,
                        setActiveFeatureItem
                      }) => {
  const containerRef = useRef(null);
  const items = navItems || [];

  // Get active item index from Redux store or use default
  const activeItemIndex = useMemo(() => {
    if (activeFeatureItems && partId && activeFeatureItems[partId] !== undefined) {
      return activeFeatureItems[partId];
    }
    return defaultActiveFeatureIndex;
  }, [activeFeatureItems, partId, defaultActiveFeatureIndex]);

  // Set initial active item if not set in Redux
  useEffect(() => {
    if (partId && activeFeatureItems && activeFeatureItems[partId] === undefined) {
      setActiveFeatureItem(partId, defaultActiveFeatureIndex);
    }
  }, [partId, activeFeatureItems, defaultActiveFeatureIndex, setActiveFeatureItem]);

  const setActiveItemIndex = useMemo(() => {
    return (index) => {
      if (partId) {
        setActiveFeatureItem(partId, index);
      }
    };
  }, [partId, setActiveFeatureItem]);

  // Configuring the grid layout
  const { gridWidth, gridHeight } = useGridDimensions(windowHeight, isMobile);
  const { columnCount, rowHeight } = getGridColumnDimensions(lookViewType);
  const columnWidth = Math.floor(gridWidth / columnCount) - 8 / columnCount; // Ensure width is an integer to avoid overflow
  const rowCount = Math.ceil(items.length / columnCount);

  return (
    <div className="side-level2__content-grid" ref={containerRef}>
      <Grid
        width={gridWidth}
        height={shouldShowFullHeight ? rowCount * rowHeight : gridHeight} // Use full container height
        columnCount={columnCount}
        columnWidth={columnWidth}
        rowCount={rowCount}
        rowHeight={rowHeight}
        cellRenderer={({ columnIndex, key, rowIndex, style }) => {
          const index = rowIndex * columnCount + columnIndex;
          if (index >= items.length) return null;
          return (
            <FeaturesRow
              key={key}
              style={style}
              feature={items[index].part ? items[index].part : items[index]}
              featureGroup={featureGroup}
              index={index}
              activeItemIndex={activeItemIndex}
              setActiveItemIndex={setActiveItemIndex}
              itemClickCallback={itemClickCallback}
            />
          );
        }}
      />
    </div>
  );
};

const mapStateToProps = (store) => {
  const { isMobile } = store.serverState;
  const { lookViewType } = store.lookState;
  const { activeFeatureItems } = store.sqftFeatureGridReducer; // Add this line

  return {
    isMobile,
    lookViewType,
    activeFeatureItems
  };
};

const mapDispatchToProps = {
  setActiveFeatureItem,
};

export default connect(mapStateToProps, mapDispatchToProps)(FeaturesGrid);
